import { Link } from 'react-router-dom';
import { CONTACT } from '@/lib/constants';

export function ContactoSection() {
  return (
    <section id="contacto">
      <div className="wrap">
        <div className="contacto-hd reveal">
          <span className="eyebrow">Estamos para ti</span>
          <h2 className="st">CONTÁCTANOS</h2>
        </div>
        <div className="info-strip">
          <div className="info-col reveal d1">
            <h4>UBICACIÓN</h4>
            <p>
              {CONTACT.address.line1}<br />
              {CONTACT.address.line2}<br />
              {CONTACT.address.line3}
            </p>
            <Link
              to="/sedes"
              style={{
                display: 'inline-block',
                marginTop: 10,
                fontFamily: 'var(--fd)',
                fontSize: '.72rem',
                letterSpacing: '2px',
                color: 'var(--orange)',
              }}
            >
              VER TODAS LAS SEDES →
            </Link>
          </div>

          <div className="info-col reveal d2">
            <h4>CONTACTO</h4>
            <p>
              <a href={`tel:${CONTACT.phoneE164}`}>{CONTACT.phone}</a><br />
              <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a><br />
              <a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noopener">
                WhatsApp directo →
              </a>
            </p>
          </div>

          <div className="info-col reveal d3">
            <h4>HORARIOS</h4>
            <p>
              {CONTACT.horario.map((h, i) => (
                <span key={h}>
                  {h}
                  {i < CONTACT.horario.length - 1 && <br />}
                </span>
              ))}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
